<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content>
    <v-form
      ref="queryForm"

    >
      <v-row
        align="center"
      >

        <v-col
          cols="2"
          xs="4"
        >
          <z-source-selector label="公司" v-model="queryData.companyId" source="CompanySelector"></z-source-selector>
        </v-col>
        <v-col
          cols="2"
          xs="4"
        >
          <v-text-field
            clearable
            v-model="queryData.roleName"
            label="名称"
            single-line
          ></v-text-field>
        </v-col>



        <v-col
          cols="2"
          xs="4"
        >
          <v-btn

            :loading="loading.queryRequest"
            @click="handleQuery"
          >
            搜索
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>
          <v-btn

            class="ma-2"
            @click="resetQuery"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-form>
    <v-row>
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.list"
        :options.sync="dataTable.options"
        :server-items-length="dataTable.total"
        :loading="loading.queryRequest"
      >
        <template v-slot:top>
          <v-toolbar height="40" flat>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog.add" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on">添加
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">角色添加</span>
                </v-card-title>

                <v-card-text>
                  <v-container>

                    <v-form ref="addForm" v-model="formValid.add"  >
                      <v-row align="center">
                        <v-col cols="6">
                        <z-source-selector label="公司" v-model="addData.companyId" :rules="[v => !!v || '公司为必选项']"
                                             source="CompanySelector"></z-source-selector>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="6">
                          <v-text-field disabled v-model="addData.roleName" label="角色名称" :rules="[v => !!v || '角色名称为必选项']" ></v-text-field>
                        </v-col>
                      </v-row>

                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog.add = false">关闭</v-btn>
                  <v-btn color="blue darken-1" :loading="loading.addRequest" :disabled="!formValid.add" text
                         @click="addCommit">提交
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <!--<v-icon-->
          <!--small-->
          <!--class="mr-4"-->
          <!--@click="editItem(item)"-->
          <!--&gt;-->
          <!--mdi-pencil-->
          <!--</v-icon>-->
          <v-icon
            small
            @click="handleDelete(item)"
          >
            mdi-delete
          </v-icon>
          <v-icon
            small
            class="ml-2"
            @click="handleMenuBind(item)"
          >
            view_list
          </v-icon>


        </template>


      </v-data-table>
    </v-row>

    <v-dialog
      v-model="dialog.delete"
      width="300"
    >
      <v-card>
        <v-card-title>
          <span >请确认是否删除</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog.delete = false">取消</v-btn>
          <v-btn
            color="error"
            text
            @click="deleteCommit"
          >
            删除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.menuBind"
      width="400"
    >
      <v-card>
        <v-card-title>
          <span >菜单绑定</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="menuBindForm" v-model="formValid.menuBind" >

              <v-row>
                <v-col cols="10">
                  <z-source-selector label="菜单列表" v-model="menuBindData.menuIdList" multiple
                                     source="MenuSelector"></z-source-selector>
                </v-col>

              </v-row>

            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog.menuBind = false">取消</v-btn>
          <v-btn
            text
            @click="menuBindCommit"
            :loading="loading.menuBindRequest"
          >
            提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-notify ref="notify" ></z-notify>

  </v-content>
</template>

<script>
  import {queryRequest, addRequest, deleteRequest, menuBindRequest} from '@/api/role'

  export default {
    name: "RoleManagement",
    data() {
      return {
        dialog:{
          add: false,
          update: false,
          delete: false,
          menuBind:false,
        },
        loading: {
          queryRequest: false,
          addRequest: false,
          deleteRequest: false,
          menuBindRequest: false
        },
        formValid: {
          add: false,
          menuBind: false
        },
        dataTable:{
          total: 0,
          list: [],
          options: {},
          headers: [
            {text: '角色名', value: 'roleName', sortable: false},
            {text: '所属公司', value: 'companyName'},
            {text: '创建时间', value: 'createDateTime'},
            {text: '操作', value: 'actions', sortable: false},
          ],
        },
        queryData: {
          roleName: '',
          companyId: '',
          sortInfo: {
            sortBy: [],
            sortDesc: []
          },
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          }
        },
        addData: {
          roleName: '',
          companyId: '',
        },
        deleteData:{},
        menuBindData:{
          roleId:'',
          menuIdList:[]
        }
      }
    },
    watch: {
      'dataTable.options': {
        handler(val) {
          this.queryData.pagedQueryInfo.index = val.page
          this.queryData.pagedQueryInfo.pageSize = val.itemsPerPage
          this.queryData.sortInfo.sortBy = val.sortBy
          this.queryData.sortInfo.sortDesc = val.sortDesc
          this.handleQuery()
        }
      }
    },
    methods: {
      handleQuery() {
        this.loading.queryRequest = true
        queryRequest(this.queryData).then(res => {
          this.dataTable.list = res.list
          this.dataTable.total = res.total
          this.loading.queryRequest = false
        }).catch(err => {
          this.loading.queryRequest = false
        })
      },
      resetQuery() {
        this.$refs.queryForm.reset()
      },
      editItem() {

      },
      handleDelete(item ) {
        this.deleteData = item
        this.dialog.delete = true
      },
      addCommit() {
        if(this.formValid.add){
          this.loading.addRequest = true
          addRequest(this.newItem).then(res => {
            this.loading.addRequest = false
            this.dialog.add = false
            this.handleQuery()
            this.$refs.notify.show("添加成功",{timeout:1000})
          }).catch(err => {
            console.error(err)
          })
        }

      },
      deleteCommit(){
        this.dialog.delete = false
        deleteRequest(this.deleteData.id).then(res => {
          this.$refs.notify.show("删除成功",{timeout:1000})
          this.handleQuery()
        }).catch(err => {
          console.error(err)
        })
      },
      handleMenuBind(item){
        this.menuBindData.roleId = item.id
        this.menuBindData.menuIdList = item.menuIdList
        this.dialog.menuBind = true
      },
      menuBindCommit(){
        this.loading.menuBindRequest = true
        menuBindRequest(this.menuBindData).then(res => {
          this.loading.menuBindRequest = false
          this.$refs.notify.show("绑定成功",{timeout:1000})
          this.dialog.menuBind = false
          this.handleQuery()
        }).catch(err => {
          console.error(err)
          this.loading.menuBindRequest = false
        })
      }
    }
  }
</script>

<style scoped>

</style>